import { configureStore, combineReducers, Middleware } from '@reduxjs/toolkit';
import { useDispatch as useDispatchDefault, useSelector as useSelectorDefault } from 'react-redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';

import { config } from '~/config';

import reducers from './reducers';
import sagas from './sagas';

const sagaMiddleware = createSagaMiddleware();

// Cast SagaMiddleware to Middleware to satisfy TS compiler
const middleware = [sagaMiddleware as Middleware];

if (config.environment !== 'prd') {
  middleware.push(createLogger());
}

const store = configureStore({
  reducer: combineReducers(reducers),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
});

sagaMiddleware.run(function* () {
  yield all(sagas);
});

type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

/* Use throughout App instead of plain `useDispatch` and `useSelector` */
export const useDispatch = useDispatchDefault.withTypes<AppDispatch>();
export const useSelector = useSelectorDefault.withTypes<RootState>();

export default store;
